var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.875 0C4.11875 0 3.5 0.61875 3.5 1.375V20.625C3.5 21.3813 4.11875 22 4.875 22H18.625C19.3813 22 20 21.3813 20 20.625V5.5L14.5 0H4.875Z",
    fill: "#E2E5E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.875 5.5H20L14.5 0V4.125C14.5 4.88125 15.1187 5.5 15.875 5.5Z",
    fill: "#B0B7BD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.625L15.875 5.5H20V9.625Z",
    fill: "#CAD1D8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 17.875C17.25 18.2531 16.9406 18.5625 16.5625 18.5625H1.4375C1.05937 18.5625 0.75 18.2531 0.75 17.875V11C0.75 10.6219 1.05937 10.3125 1.4375 10.3125H16.5625C16.9406 10.3125 17.25 10.6219 17.25 11V17.875Z",
    fill: "#576D7E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.08241 13.3835H4.12059C3.64209 13.3835 3.64209 12.6802 4.12059 12.6802H6.72072C7.21022 12.6802 7.21022 13.3835 6.72072 13.3835H5.80772V16.1589C5.80772 16.6367 5.08172 16.6484 5.08172 16.1589V13.3835H5.08241Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01931 14.0152L9.97631 12.8169C10.2623 12.4436 10.8171 12.9214 10.5043 13.2789C10.1743 13.6694 9.8285 14.0929 9.49781 14.5261L10.6198 15.9224C10.9216 16.3349 10.3173 16.7309 10.0203 16.3239L9.009 15.0266L8.01419 16.3514C7.73369 16.7522 7.11219 16.3019 7.42638 15.9279L8.5305 14.5261C8.18469 14.0922 7.84919 13.6694 7.51369 13.2789C7.16719 12.8664 7.81069 12.4436 8.063 12.8286L9.01931 14.0152Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1911 13.3835H11.23C10.7515 13.3835 10.7515 12.6802 11.23 12.6802H13.8294C14.3189 12.6802 14.3189 13.3835 13.8294 13.3835H12.9171V16.1589C12.9171 16.6367 12.1911 16.6484 12.1911 16.1589V13.3835Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5625 18.5625H3.5V19.25H16.5625C16.9406 19.25 17.25 18.9406 17.25 18.5625V17.875C17.25 18.2531 16.9406 18.5625 16.5625 18.5625Z",
    fill: "#CAD1D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxt);
export default __webpack_public_path__ + "static/media/txt.e70bd320a52ff0202e131e7ae8495276.svg";
export { ForwardRef as ReactComponent };